import React from 'react'
import { Link } from 'gatsby'
import { blogUrl } from '../util/constants'

const menuItems = [
  ['', 'Intro'],
  ['who', 'Who We Are'],
  ['how', 'How We Help'],
  ['startups', 'Our Startups'],
  ['interests', 'What Interests Us'],
  ['blog', 'Blog'],
]

const Menu = ({ current }) => (
  <ul className="menu">
    {menuItems.map(([slug, title]) => {
      if (slug !== 'blog') {
        return (
          <li key={title} className={slug === current ? 'current' : ''}>
            <Link to={`/${slug}${slug && '/'}`}>{title}</Link>
          </li>
        )
      } else {
        return (
          <li key={title}>
            <a href={blogUrl}>{title}</a>
          </li>
        )
      }
    })}
  </ul>
)

export default Menu
